<template>
  <div id="app" class="app">
    <router-view/>
    <app-modal-container></app-modal-container>
  </div>
</template>

<script>

import AppModelContainer from '@/components/admin/app-modal/ModalContainer.vue'
import { mapActions } from 'vuex'; 
import Events from '@/app/events.js'

export default {
	components:{"app-modal-container": AppModelContainer},
  name: 'app',
  methods: {

    ...mapActions({
      authenticationCheck: 'authenticationCheck'
    })

  },
  created(){

    this.authenticationCheck();

    Events.$on('auth-success', authSuccess => {

      if(this.$router.currentRoute.name == "login"){
        return this.$router.replace({ name: 'watchedItems' });
      }

      return null

    })
  }

}
</script>

<style lang="scss">
@import "../sass/main.scss";

body {
  height: 100%;

  #app {
    height: 100%;
  }
}
</style>
